<template>
    <component :is="layout">
        <router-view/>
    </component>
</template>

<script>
import './App.scss';

export default {
    name: 'App',
    computed: {
        layout() {
            return this.$route?.meta?.layout || 'Basic';
        },
    },
}
</script>
